import React, { useEffect, useRef } from 'react';

const SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let loader;
const loadScript = () => {
  if (window.turnstile) return Promise.resolve();
  if (!loader) {
    loader = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SRC; s.async = true; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return loader;
};

// Cloudflare Turnstile widget; onToken('') when the token expires/fails. Change resetKey to get a fresh token.
export const TurnstileWidget = ({ onToken, resetKey = 0, testId = 'turnstile-widget' }) => {
  const box = useRef(null);
  const widget = useRef(null);
  const cb = useRef(onToken);
  cb.current = onToken;

  useEffect(() => {
    let alive = true;
    loadScript().then(() => {
      if (!alive || !box.current || widget.current !== null) return;
      widget.current = window.turnstile.render(box.current, {
        sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
        theme: 'dark',
        language: 'it',
        callback: (t) => cb.current(t),
        'expired-callback': () => cb.current(''),
        'error-callback': () => cb.current(''),
      });
    }).catch(() => cb.current(''));
    return () => {
      alive = false;
      if (widget.current !== null && window.turnstile) window.turnstile.remove(widget.current);
      widget.current = null;
    };
  }, []);

  useEffect(() => {
    if (resetKey && widget.current !== null && window.turnstile) { cb.current(''); window.turnstile.reset(widget.current); }
  }, [resetKey]);

  return <div ref={box} className="flex justify-center my-3 min-h-[65px]" data-testid={testId} />;
};

export default TurnstileWidget;
